<template>
  <div id="app" style="height:100%">
    <!--<div id="nav">
      <router-link to="/">Home</router-link> 
      <router-link to="/about">About</router-link>
    </div>-->
    <headers/>
    <router-view/>
  </div>
</template>

<script>
  
  import headers from './components/Header.vue'
  export default {
    name: "App",
    components: {
      headers
    }

  };
</script>
<style>
.vn-message{
    color: beige;
}
/*
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}*/
</style>
